import React, { FunctionComponent } from 'react';
import { AnalyticsComponent } from '@inplayer-org/inplayer-ui';
import ColorPicker from './ColorPicker';

interface OwnProps {
  displayBtnColorPicker: boolean;
  preview_buttons_bg_color: string;
  displayTextColorPicker: boolean;
  preview_buttons_text_color: string;
  previewTemplateId?: number;
  handleClick: (displayPicker: string) => any;
  handleClose: (displayPicker: string) => any;
  handlePickerChange: (elementName: string) => any;
}

const PreviewTemplate3 = 3;

const PaywallButtonConfigurationContent: FunctionComponent<OwnProps> = ({
  displayBtnColorPicker,
  preview_buttons_bg_color,
  displayTextColorPicker,
  preview_buttons_text_color,
  previewTemplateId,
  handleClick,
  handleClose,
  handlePickerChange,
}) => {
  return (
    <>
      <ColorPicker
        tag="background_color_picker"
        showColorPicker={displayBtnColorPicker}
        displayPicker="displayBtnColorPicker"
        element_name="preview_buttons_bg_color"
        background_color={preview_buttons_bg_color}
        text="Background color"
        handleClick={handleClick('displayBtnColorPicker')}
        handleClose={handleClose('displayBtnColorPicker')}
        handlePickerChange={handlePickerChange('preview_buttons_bg_color')}
      />
      {previewTemplateId !== PreviewTemplate3 && (
        <ColorPicker
          tag="text_color_picker"
          showColorPicker={displayTextColorPicker}
          displayPicker="displayTextColorPicker"
          element_name="preview_buttons_text_color"
          background_color={preview_buttons_text_color}
          text="Text color"
          handleClick={handleClick('displayTextColorPicker')}
          handleClose={handleClose('displayTextColorPicker')}
          handlePickerChange={handlePickerChange('preview_buttons_text_color')}
        />
      )}
    </>
  );
};

export default PaywallButtonConfigurationContent;
